import { Select } from 'radix-ui'
import { cn } from '~/shared/lib/cn'

export function SelectGroup({ className, ...props }: React.ComponentProps<typeof Select.Group>) {
  return (
    <Select.Group
      className={cn(className)}
      {...props}
    />
  )
}
